<template>
  <bioreq-table ref="table" :view="view" table-type="pending"/>
</template>

<script>
import { mapState } from 'vuex'
import bioreqTable from './pendingTable'

export default {
  components: {
    bioreqTable
  },
  computed: {
    ...mapState('bioreq', {
      view: '_defaultView'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/client/bioreq/pending.vue